import { render, staticRenderFns } from "./AdminEvenements.vue?vue&type=template&id=31b584fe"
import script from "./AdminEvenements.vue?vue&type=script&lang=js"
export * from "./AdminEvenements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports